import React, { useContext, useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Checkbox,
  Typography,
  message,
  notification,
  Flex,
  Radio,
  Modal,
  Alert,
} from "antd";
import { useCompany } from "../../context/companyContext";
import {
  UserOutlined,
  LockOutlined,
  MailOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import ReCAPTCHA from "react-google-recaptcha";
import OTPInput from "../../components/auth/OTPInput"; // Import OTP input component
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import "../landing/LandingPageNew.css"; // Theme variables
import "./whatsapp-auth.css"; // WhatsApp themed CSS
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { AuthContext } from "../../context/authContext";
import { useUserContext } from "../../context/userContext";
import ForgotPassword from "../../components/auth/ForgotPassword";
import axiosconfig from "../../config/axiosConfig";
import {
  changevalidations,
} from "../../utils/formValidations";
import { handleBeforeInput } from "../../utils/validationFunctions";
import video from "../../assets/gif/emailVerification.mp4";
import forgotPasswordImageSrc from "../../assets/images/forgetpass-new.png";
const forgotPasswordImage = forgotPasswordImageSrc;

const { Title, Text } = Typography;

// No longer needed as we are using custom captcha

const LoginPage = () => {
  const [form] = Form.useForm();
  const { login } = useContext(AuthContext);
  const { fetchUserContext } = useUserContext();
  const { companyData, updateCustomerUuid } = useCompany();
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const { theme } = useOutletContext() || { theme: 'light' };
  const [slideClass, setSlideClass] = useState('');

  // Slide direction on mount
  useEffect(() => {
    const dir = sessionStorage.getItem('auth-slide');
    if (dir) {
      setSlideClass(dir === 'right' ? 'slide-from-right' : 'slide-from-left');
      sessionStorage.removeItem('auth-slide');
    }
  }, []);

  const goToSignup = () => {
    sessionStorage.setItem('auth-slide', 'right');
    navigate('/signup');
  };

  const [step1Data, setStep1Data] = useState(null);
  const [step, setStep] = React.useState(1);
  const [formValues, setFormValues] = React.useState({});
  const [otp, setOtp] = React.useState("");
  const [otpLoading, setOtpLoading] = React.useState(false);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // eslint-disable-next-line no-unused-vars
    const company_type = sessionStorage.getItem('company_type');
  }, []);


  // Handle OTP input change
  const handleOTPChange = (value) => {
    setOtp(value);
    form.setFieldsValue({ otp: value });
    // Only validate if we have a complete OTP
    if (value.length === 6) {
      form.validateFields(['otp']);
    }
  };
  const [forgetPasswordFlag, setForgetPasswordFlag] = React.useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(0);
  const [otpSentVia, setOtpSentVia] = useState("email");
  const [isPhoneInput, setIsPhoneInput] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [contactMethod, setContactMethod] = useState("phone"); // 1. Add this

  // Google reCAPTCHA state
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [captchaError, setCaptchaError] = useState("");
  const recaptchaRef = React.useRef(null);

  // Resend captcha state (reCAPTCHA)
  const [resendCaptchaVerified, setResendCaptchaVerified] = useState(false);
  const [resendCaptchaError, setResendCaptchaError] = useState("");
  const resendRecaptchaRef = React.useRef(null);
  const [isResendModalVisible, setIsResendModalVisible] = useState(false);

  // Account disabled / deactivated alert (shown inline on the form)
  const [accountDisabledAlert, setAccountDisabledAlert] = useState(null);

  // Handle reCAPTCHA verification
  const handleCaptchaChange = (token) => {
    setCaptchaVerified(!!token);
    setCaptchaError("");
  };

  // Handle reCAPTCHA expiry
  const handleCaptchaExpired = () => {
    setCaptchaVerified(false);
  };

  // Handle resend reCAPTCHA verification
  const handleResendCaptchaChange = (token) => {
    setResendCaptchaVerified(!!token);
    setResendCaptchaError("");
  };

  const handleResendCaptchaExpired = () => {
    setResendCaptchaVerified(false);
  };

  // Handle phone input change
  // const handlePhoneChange = (value, country) => {
  //   setPhoneNumber(value);
  //   const code = `${country.dialCode}`;
  //   setCountryCode(code);

  //   // Remove country code from value for mobile
  //   const countryCodeWithPlus = `+${country.dialCode}`;
  //   let mobileNumber = value.startsWith(countryCodeWithPlus)
  //     ? value.slice(countryCodeWithPlus.length)
  //     : value.replace(/^\+?\d{1,4}/, "");

  //   mobileNumber = mobileNumber.replace(/^0+/, "").trim();

  //   form.setFieldsValue({
  //     emailormobile: mobileNumber,
  //     countrycode: code,
  //   });
  // };
  const handlePhoneChange = (value, country) => {
    // Existing code...
    setPhoneNumber(value);
    const code = `+${country.dialCode}`;
    setCountryCode(code);

    form.setFieldsValue({
      mobile: value.replace(code, ""),
      countrycode: code,
    });
  };
  // 2. Add this handler
  const handleContactMethodChange = (e) => {
    const method = e.target.value;
    setContactMethod(method);

    // Clear the other field when switching
    if (method === "email") {
      setPhoneNumber("");
      form.setFieldsValue({ emailormobile: "", countrycode: "" });
    } else {
      form.setFieldsValue({ emailormobile: "" });
    }

    // Also clear validation errors
    form.validateFields(
      method === "email" ? ["emailormobile"] : ["emailormobile"]
    );
  };

  const handleStep1Finish = (values) => {
    const isPhone = contactMethod === "phone";
    const isEmail = contactMethod === "email";

    // Verify reCAPTCHA
    if (!captchaVerified) {
      setCaptchaError("Please verify that you are not a robot");
      return;
    }

    const moblilewithccp = values.emailormobile;
    const localNumber = moblilewithccp.startsWith(countryCode.replace("+", ""))
      ? moblilewithccp.slice(countryCode.replace("+", "").length)
      : moblilewithccp;

    // If using phone input, format the values properly
    if (isPhone) {
      values.mobile = localNumber;
      values.countrycode = countryCode.replace("+", "");
    } else if (isEmail) {
      values.mobile = '';
      values.email = values.emailormobile;
    }
    console.log(localNumber);

    // No need to send captcha token to backend as it's verified client-side

    // Add domain parameter from address bar
    const domain = window.location.hostname;
    const requestBody = {
      ...values,
      domain: domain
    };

    console.log('Request body with domain:', requestBody);
    setLoading(true);
    axiosconfig
      .post("/company/sendloginotp", requestBody)
      .then((response) => {
        console.log(response.data);
        if (response.data?.statuscode === 200) {
          // Set the OTP delivery method based on the response

          const msg = response.data?.entity?.otpresponse?.otpsentvia;
          // Set the OTP delivery method based on the response
          if (msg) {
            setOtpSentVia(msg);
          } else {
            // Default to email if not specified
            setOtpSentVia("");
          }
          message.success(response.data.message);
          form.resetFields();
          setFormValues(values);
          setAccountDisabledAlert(null); // clear any previous disabled alert
          setStep(2);
          setStep1Data(values);
        } else {
          message.error(
            response.data.message || "Login failed. Please try again."
          );
          // Reset reCAPTCHA on failure
          setCaptchaVerified(false);
          recaptchaRef.current?.reset();
        }
      })
      .catch((error) => {
        console.error("Login error:", error);
        const errMsg = error.response?.data?.message || error.message || "Something went wrong";
        const isDeactivated =
          error.response?.status === 403 ||
          errMsg.toLowerCase().includes('deactivated') ||
          errMsg.toLowerCase().includes('blocked') ||
          errMsg.toLowerCase().includes('disabled');

        if (isDeactivated) {
          setAccountDisabledAlert(errMsg);
        } else {
          message.error(errMsg);
        }
        // Reset reCAPTCHA on any failure
        setCaptchaVerified(false);
        recaptchaRef.current?.reset();
      })
      .finally(() => {
        setLoading(false); // <-- This ensures the loader always stops
      });
  };

  const handleOtpSubmit = (values) => {
    // console.log(step1Data);
    // values.mobile = step1Data.mobile;
    // values.countrycode = step1Data.countrycode;

      const isPhone = contactMethod === "phone";
    const isEmail = contactMethod === "email";

 if (isPhone) {
      values.mobile = step1Data.mobile;
      values.countrycode = step1Data.countrycode;
    } else if (isEmail) {
      values.mobile = '';
      values.email = step1Data.emailormobile;
    }
console.log(values);
// return

    setLoading(true);
    setOtpLoading(true);
    axiosconfig
      .post("/company/verifyloginotp", values)
      .then(async (response) => {
        console.log(response.data);
        if (response.data?.statuscode === 200) {
          // message.success(response.data.message);
          const companyname = response.data?.entity.company.companyname;
          // headerkey and sessionId are set via httpOnly cookies automatically
          const company_type = response.data?.entity.company.company_type;
          const admin_level = response.data?.entity.company.admin_level || null;
          const customeruuid = response.data?.entity.company.companyid; // This is the customeruuid

          form.resetFields();
          // Cookies are set automatically by the browser via httpOnly cookies
          // No need to store token/sessionId in sessionStorage
          sessionStorage.setItem("company_type", company_type);
          if (admin_level) sessionStorage.setItem("admin_level", admin_level);
          
          // Store customeruuid in company context and sessionStorage
          updateCustomerUuid(customeruuid);

          // Fetch user context (pages, permissions, role, parent info)
          // This may override customeruuid with effective_company_id for child admins
          let userCtxData = null;
          try {
            userCtxData = await fetchUserContext();
          } catch (e) {
            console.warn('User context fetch failed, continuing with defaults:', e);
          }

          setTimeout(() => {
            notification.success({
              message: "Login Successful",
              description: `Welcome, ${companyname}`,
            });

            try { localStorage.setItem('channelMode', 'whatsapp'); } catch { /* noop */ }
            login(response.data?.entity.company.companyid, companyname, "");
          }, 1000);
          setTimeout(() => {
            // Determine admin_level — prefer API value, fallback from userContext, then derive from company_type
            const effectiveAdminLevel = admin_level
              || userCtxData?.admin_level
              || sessionStorage.getItem('admin_level');

            if (effectiveAdminLevel) {
              // Route based on admin_level (unambiguous hierarchy position)
              switch (effectiveAdminLevel) {
                case 'mos_super_admin':
                  navigate("/dashboard/admin");
                  break;
                case 'mos_sub_admin':
                  // MOS sub-admins go to admin panel (pages control what they see)
                  navigate("/dashboard/admin");
                  break;
                case 'client_super_admin':
                  navigate("/dashboard");
                  break;
                case 'client_sub_admin':
                  // Client sub-admins go to dashboard (pages control what they see)
                  navigate("/dashboard");
                  break;
                default:
                  navigate("/dashboard");
                  break;
              }
            } else {
              // Fallback to company_type for backward compatibility
              if (userCtxData?.is_child_admin) {
                navigate("/dashboard");
              } else if (company_type === "ADMIN") {
                navigate("/dashboard/admin");
              } else if (company_type === "SOLUTION_PARTNER") {
                navigate("/dashboard/solution-partner-admin");
              } else {
                navigate("/dashboard");
              }
            }
          }, 2000);
        } else {
          message.error(
            response.data.message || "Login failed. Please try again."
          );
        }
      })
      .catch((error) => {
        console.error("Login error:", error);
        const errMsg = error.response?.data?.message || error.message || "Verification failed";
        const isDeactivated =
          error.response?.status === 403 ||
          errMsg.toLowerCase().includes('deactivated') ||
          errMsg.toLowerCase().includes('blocked') ||
          errMsg.toLowerCase().includes('disabled');

        if (isDeactivated) {
          // Account was deactivated — go back to login screen and show alert
          setAccountDisabledAlert(errMsg);
          form.resetFields(['otp']);
          setStep(1);
        } else {
          message.error(errMsg);
        }
      })
      .finally(() => {
        setLoading(false); // <-- This ensures the loader always stops
        setOtpLoading(false);
      });
  };

  const handleToggleForgotPassword = () => {
    setForgetPasswordFlag(!forgetPasswordFlag);
  };

  // Update the handleResendOtp function to directly resend the OTP without captcha verification
  const handleResendOtp = () => {
    if (!step1Data) {
      message.error("Please fill the login form first.");
      return;
    }

    // Create request body based on login method used in step 1
    const requestBody = {};

    if (contactMethod === "email") {
      requestBody.email = step1Data.emailormobile;
    } else {
      requestBody.mobile = step1Data.mobile;
      requestBody.countrycode = step1Data.countrycode;
    }

    setResendLoading(true);
    axiosconfig
      .post("/company/resendloginotp", requestBody)
      .then((response) => {
        console.log("response=>", response.data);
        if (response.data?.statuscode === 200) {
          // Update delivery method if it changed with the resend
          const resp = response.data.entity.otpreponse;
          if (resp) {
            setOtpSentVia(resp.otpsentvia);
          }

          // Clear the OTP field when new OTP is sent successfully
          form.setFieldValue("otp", "");
          setOtp(""); // Clear OTP state

          message.success(resp.message);
          setResendCooldown(120); // Reset cooldown
        } else {
          message.error(
            response.data.message || "Failed to resend OTP. Please try again."
          );
        }
      })
      .catch((error) => {
        console.error("Login error:", error);
        message.error(
          "An error occurred while resending OTP. Please try again."
        );
      })
      .finally(() => {
        setResendLoading(false);
      });
  };

  React.useEffect(() => {
    let timer;
    if (resendCooldown > 0) {
      timer = setTimeout(() => setResendCooldown(resendCooldown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [resendCooldown]);

  return (
    <div className="wa-auth-container" data-theme={theme}>

      {/* ── Animated background ── */}
      <div className="wa-auth-bg-anim" aria-hidden="true">
        <div className="wa-bg-bubble-shape s1"></div>
        <div className="wa-bg-bubble-shape s2"></div>
        <div className="wa-bg-bubble-shape s3"></div>
        <div className="wa-bg-bubble-shape s4"></div>
        <div className="wa-bg-bubble-shape s5"></div>
        <div className="wa-bg-bubble-shape s6"></div>
        <div className="wa-bg-dot d1"></div>
        <div className="wa-bg-dot d2"></div>
        <div className="wa-bg-dot d3"></div>
        <div className="wa-bg-dot d4"></div>
        <div className="wa-bg-dot d5"></div>
        <div className="wa-bg-orb-light o1"></div>
        <div className="wa-bg-orb-light o2"></div>
        <div className="wa-bg-orb-light o3"></div>
        <div className="wa-bg-wave-bars">
          <div className="wa-bg-wave-bar"></div>
          <div className="wa-bg-wave-bar"></div>
          <div className="wa-bg-wave-bar"></div>
          <div className="wa-bg-wave-bar"></div>
          <div className="wa-bg-wave-bar"></div>
          <div className="wa-bg-wave-bar"></div>
          <div className="wa-bg-wave-bar"></div>
          <div className="wa-bg-wave-bar"></div>
        </div>
      </div>

      {/* ── Form card ── */}
      <div className={`wa-auth-split-card wa-auth-card--login ${slideClass}`}>
        <div className="wa-auth-form-side">
        <div className="wa-auth-form-container">

      {/* Add Captcha Modal for Resend OTP */}
      <Modal
        title="Security Verification"
        open={isResendModalVisible}
        onCancel={() => setIsResendModalVisible(false)}
        footer={[
          <>
            <Button key="cancel" onClick={() => setIsResendModalVisible(false)}>
              Cancel
            </Button>
            <Button
              key="submit"
              type="primary"
              className="wa-auth-button"
              // onClick={performResendOtp}
              loading={resendLoading}
            >
              Verify & Resend OTP
            </Button>
          </>,
        ]}
      >
        <div style={{ marginBottom: "16px" }}>
          <Text>
            Please complete the captcha verification to resend the OTP.
          </Text>
        </div>

        <div className="wa-recaptcha-wrap" style={{ marginBottom: 8 }}>
          <ReCAPTCHA
            ref={resendRecaptchaRef}
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            onChange={handleResendCaptchaChange}
            onExpired={handleResendCaptchaExpired}
            size="normal"
          />
        </div>
        {resendCaptchaError && (
          <Text type="danger" style={{ display: 'block', textAlign: 'center', marginBottom: 8 }}>{resendCaptchaError}</Text>
        )}
      </Modal>
        {forgetPasswordFlag ? (
          <ForgotPassword
            handleToggleForgotPassword={handleToggleForgotPassword}
            onClose={() => setForgetPasswordFlag(false)}
          />
        ) : (
          <>
            <div className="wa-auth-header">
              <Title level={2} className="wa-auth-title">
                {step === 1 ? `Welcome to ${companyData.companyName}` : "OTP Verification"}
              </Title>

              {step === 1 ? (
                <Text type="secondary" className="wa-auth-subtitle">
                  Sign in to manage and grow your business.
                </Text>
              ) : (
                <div className="wa-auth-subtitle">
                  <Text
                    strong
                    style={{
                      fontSize: "15px",
                      display: "block",
                      marginBottom: "4px",
                    }}
                  >
                    Enter the 6-digit OTP
                  </Text>
                  <Flex align="center" justify="center" gap="small">
                    {otpSentVia?.toLowerCase() === "whatsapp" ? (
                      <>
                        <WhatsAppOutlined style={{ fontSize: "16px", color: "#25D366" }} />
                        <Text type="secondary">
                          Sent to your{" "}
                          <Text strong style={{ color: "#128C7E" }}>
                            WhatsApp
                          </Text>
                        </Text>
                      </>
                    ) : otpSentVia?.toLowerCase() === "sms" ? (
                      <>
                        <span
                          role="img"
                          aria-label="sms"
                          style={{ fontSize: "16px" }}
                        >
                          💬
                        </span>{" "}
                        <Text type="secondary">
                          Sent to your{" "}
                          <Text strong style={{ color: "#128C7E" }}>
                            phone via SMS
                          </Text>
                        </Text>
                      </>
                    ) : (
                      <>
                        <MailOutlined style={{ color: "#128C7E" }} />{" "}
                        <Text type="secondary">
                          Sent to your{" "}
                          <Text strong style={{ color: "#128C7E" }}>
                            Email
                          </Text>
                        </Text>
                      </>
                    )}
                  </Flex>
                </div>
              )}
            </div>
            {step === 1 ? (
              <Form
                name="login_form"
                initialValues={{ remember: true }}
                onFinish={handleStep1Finish}
                layout="vertical"
                form={form}
              >
                {/* Add the radio group */}
                <Form.Item label="Login with">
                  <Radio.Group
                    onChange={handleContactMethodChange}
                    value={contactMethod}
                  >
                    <Radio value="phone">Mobile</Radio>
                    <Radio value="email">Email</Radio>
                  </Radio.Group>
                </Form.Item>

                {/* Show either email or phone input */}
                {contactMethod === "email" ? (
                  <Form.Item
                    name="emailormobile"
                    label="Email"
                    rules={[
                      { required: true, message: "Please enter your email" },
                      { type: "email", message: "Invalid email" },
                    ]}
                  >
                    <Input
                      prefix={<MailOutlined className="wa-input-prefix" />}
                      placeholder="Enter Email"
                      className="wa-input"
                    />
                  </Form.Item>
                ) : (
                  <>
                    <Form.Item
                      name="emailormobile"
                      label="Mobile Number"
                      rules={[
                        {
                          required: true,
                          message: "Please enter a mobile number",
                        },
                      ]}
                    >
                      <PhoneInput
                        country={"in"}
                        value={phoneNumber}
                        onChange={handlePhoneChange}
                        inputClass="wa-input"
                        containerClass="wa-phone-input"
                        dropdownClass="wa-phone-dropdown"
                        enableSearch={true}
                        disableSearchIcon={true}
                        searchPlaceholder="Search country..."
                        countryCodeEditable={false}
                      />
                    </Form.Item>
                    {/* Hidden field to store country code */}
                    <Form.Item name="countrycode" hidden initialValue="91" />
                  </>
                )}

                <Form.Item
                  name="password"
                  label="Password"
                  rules={[
                    { required: true, message: "Please input your Password!" },
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined className="wa-input-prefix" />}
                    placeholder="Password"
                    className="wa-input"
                    disabled={loading}
                  />
                </Form.Item>

                <Form.Item
                  className="wa-captcha-wrapper"
                >
                  <div className="wa-recaptcha-wrap">
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                      onChange={handleCaptchaChange}
                      onExpired={handleCaptchaExpired}
                      size="normal"
                    />
                  </div>
                  {captchaError && (
                    <Text type="danger" style={{ display: 'block', textAlign: 'center', marginTop: 4 }}>{captchaError}</Text>
                  )}
                </Form.Item>
                <Form.Item style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                  <Checkbox>Remember me</Checkbox>
                  <Button
                    type="link"
                    className="wa-auth-link"
                    onClick={() => setForgetPasswordFlag(true)}
                    disabled={loading}
                    style={{ padding: 0 }}
                  >
                    Forgot Password?
                  </Button>
                </Form.Item>

                {/* Account disabled alert — shown when backend returns 403 / deactivated message */}
                {accountDisabledAlert && (
                  <Alert
                    type="error"
                    showIcon
                    message="Account Disabled"
                    description={accountDisabledAlert}
                    closable
                    onClose={() => setAccountDisabledAlert(null)}
                    style={{ marginBottom: 16, borderRadius: 8 }}
                  />
                )}

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    className="wa-auth-button"
                    loading={loading}
                    disabled={loading}
                  >
                    Next
                  </Button>
                </Form.Item>
              </Form>
            ) : (
              <Form onFinish={handleOtpSubmit}>
                <div className="wa-otp-section">
                  <div className="wa-otp-animation">
                    <video
                      src={video}
                      alt="Email verification"
                      style={{ width: "120px", height: "120px" }}
                      autoPlay
                      loop
                    />
                  </div>
                  
                  <Form.Item
                    name="otp"
                    label="Enter 6-digit OTP"
                    rules={[
                      { required: true, message: "Please enter the complete OTP" },
                      { pattern: /^\d{6}$/, message: "OTP must be exactly 6 digits" }
                    ]}
                    className="wa-otp-form-item"
                  >
                    <OTPInput
                      length={6}
                      value={otp}
                      onChange={handleOTPChange}
                    />
                  </Form.Item>
                </div>

                {/* Add this Form.Item for resend OTP button */}
                <Form.Item>
                  <Button
                    type="link"
                    onClick={handleResendOtp}
                    disabled={resendLoading || resendCooldown > 0}
                    loading={resendLoading}
                    block
                    className="wa-auth-link"
                    style={{ padding: 0 }}
                  >
                    {resendCooldown > 0
                      ? `Resend OTP (${resendCooldown}s)`
                      : "Resend OTP"}
                  </Button>
                </Form.Item>

                {/* Account disabled alert — in case account was deactivated after OTP was sent */}
                {accountDisabledAlert && (
                  <Alert
                    type="error"
                    showIcon
                    message="Account Disabled"
                    description={accountDisabledAlert}
                    closable
                    onClose={() => setAccountDisabledAlert(null)}
                    style={{ marginBottom: 16, borderRadius: 8 }}
                  />
                )}

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    className="wa-auth-button"
                    loading={otpLoading}
                    disabled={otpLoading}
                  >
                    Verify OTP
                  </Button>
                </Form.Item>
              </Form>
            )}

            <div className="wa-auth-footer">
              <Text type="secondary">
                Don't have an account?{" "}
                <button type="button" className="wa-auth-link" onClick={goToSignup}>
                  Sign Up
                </button>
              </Text>
            </div>
          </>
        )}
        </div>
        </div>{/* end wa-auth-form-side */}

      </div>{/* end wa-auth-split-card */}
    </div>
  );
};

export default LoginPage;
